<template>
  <Wrapper pageName="青藤会员">
    <div class="container">
      <el-tabs v-model="activeName">
        <el-tab-pane label="待审批" name="first">
          <PageTab  :applyStatus="0" v-if="activeName==='first'"></PageTab>
        </el-tab-pane>
        <el-tab-pane label="已驳回" name="second">
          <PageTab  :applyStatus="-1" v-if="activeName==='second'"></PageTab>
        </el-tab-pane>
        <el-tab-pane label="已通过" name="third">
          <PageTab  :applyStatus="1" v-if="activeName==='third'"></PageTab>
        </el-tab-pane>
      </el-tabs>
    </div>
  </Wrapper>

</template>

<script>
import Wrapper from '@/components/page/Wrapper.vue'
import PageTab from './pageTab.vue'

export default {
  name: 'Account',
  components: {
    Wrapper,
    PageTab
  },
  data () {
    return {
      activeName: 'first'
    }
  },
  computed: {

  },
  watch: {

  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.container{
  background-color: #fff;
  margin: 20px;
  padding: 20px;
  height: 100%;
}
</style>

